//global.js
(function($, window, document, undefined) {
  "use strict";

  window.requestParms = {
    longestShower: 0,
    backToBackShowers: 0,
    simultaneousShowers: 0,
    largestBathTub: 0,
    customShowerFlowRate: 0,
    energySource: "",
    ventingPreference: "NotSure",
    spaceWidth: 0,
    spaceHeight: 0,
    spaceDepth: 0,
    zipCode: "37211",
    averageShowerLength: 0,
    prices: false,
    model: ""
  };
  window.ignoreUpdate = true;
  window.runRequest = false;

  window.resultsObj = { a: 1 };

  window.inProductPage = false;

  window.tankUnitsToShow = 2;
  window.tanklessUnitsToShow = 1;

  window.gaInitial = true;

  window.pbTimerID = 0;
  window.pbTimerPct = 0;
  window.ProgressBarTimer = function() {
    clearInterval(pbTimerID);
    pbTimerPct++;
    //aria-valuenow
    $("div.progress-bar").attr("style", "width:" + pbTimerPct * 10 + "%;");
    if (pbTimerPct < 10)
      pbTimerID = setInterval(function() {
        ProgressBarTimer();
      }, 1250);
  };

  window.DecimalToFraction = function(decimal) {
    function highestCommonFactor(a, b) {
      if (b == 0) return a;
      return highestCommonFactor(b, a % b);
    }
    if (decimal.indexOf(".") < 0) return decimal;
    var decimalArray = decimal.split(".");
    var outputValue = decimalArray[0];
    var dRemainder = "0." + decimalArray[1];
    var FractionBase = 32;
    var nFraction = Math.round(FractionBase * dRemainder);
    for (var n = FractionBase; n >= 2; n /= 2) {
      if (n != FractionBase) {
        nFraction /= 2;
      }
      if (nFraction % 2 != 0) {
        outputValue += "-" + nFraction + "/" + n;
        break;
      }
    }

    return outputValue;
  };

  window.MathRound = function(input, places) {
    if (typeof input == "undefined") return 0;
    if (typeof places == "undefined") places = 0;
    var x = 1;
    for (var i = 0; i < places; i++) {
      x *= 10;
    }
    var results = Math.round(input * x);
    results = results / x;
    return results;
  };

  $(document)
    .ajaxStart(function() {
      // pbTimerPct = 0;
      // $('div.progress-bar').attr('style', 'width:'+(pbTimerPct * 10) + '%;');
      // $('.progressbar').show();
      // pbTimerID = setInterval(function(){ ProgressBarTimer()}, 1250);
    })
    .ajaxComplete(function() {
      // $('.progressbar').hide();
      // clearInterval(pbTimerID);
    });

  var urlHost = "https://www.whmaas.com/api/productselector/";
  window.isStaging = /localhost|uat/i.test(window.location.hostname);
  // TODO: change partners.statewaterheaters.com and partners.hotwater.com to the staging site when it is created
  if (window.isStaging) {
    urlHost = "https://stage.whmaas.com/api/productselector/";
  }
  $.support.cors = true;
  $.ajaxSetup({
    cache: false,
    dataType: "text",
    error: function error(xhr, status, _error) {
      // alert('An AJAX error occured:\n error:' + error + '\n xhr: ' + xhr.status + '\n status: ' + status);
    },
    timeout: 60000,
    type: "GET",
    url: urlHost
  }); // ajaxSetup

  window.GetCookie = function(c_name) {
    var c_value = document.cookie;
    var c_start = c_value.indexOf(" " + c_name + "=");
    if (c_start == -1) {
      c_start = c_value.indexOf(c_name + "=");
    }
    if (c_start == -1) {
      c_value = "";
    } else {
      c_start = c_value.indexOf("=", c_start) + 1;
      var c_end = c_value.indexOf(";", c_start);
      if (c_end == -1) {
        c_end = c_value.length;
      }
      c_value = unescape(c_value.substring(c_start, c_end));
    }
    return c_value;
  };

  window.SetCookie = function(c_name, value, extmins) {
    var exdate = new Date();
    exdate.setTime(exdate.getTime() + extmins * 60 * 1000);
    //var c_value = escape(value) + ((extmins == null) ? "" : "; expires=" + exdate.toUTCString()) + "; path=/; ";
    var c_value =
      escape(value) +
      (extmins == null ? "" : "; expires=" + exdate.toGMTString()) +
      "; path=/; ";
    document.cookie = c_name + "=" + c_value;
  };

  window.SetGeoCodeCookie = function(city, state, zip) {
    if (typeof city == "undefined") city = "";
    if (typeof state == "undefined") state = "";
    if (typeof zip == "undefined") zip = "";
    var txt = "City=" + city + "&State=" + state + "&Zip=" + zip + "&Changed=1";
    SetCookie("Geocode", txt, 120);
  };

  window.StringReplace = function(searchfor, replacein, replacewith) {
    var x = 0;
    while (replacein.indexOf(searchfor) >= 0) {
      replacein = replacein.replace(searchfor, replacewith);
      if (x++ > 10) break;
    }
    return replacein;
  };
})(jQuery, window, document);
